module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/founder_doctor/1-e4a9230b53ed015675060ed3f6253091.jpg";